import { render, staticRenderFns } from "./TrashLayout.vue?vue&type=template&id=e3c8857c&"
import script from "./TrashLayout.vue?vue&type=script&lang=js&"
export * from "./TrashLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports